import { post, get } from '../axios'

// 查询导航菜单配置
export function nav_query_post(map, option) {
  return post(`${process.env.VUE_APP_NAV}/nav/query`, map, option).then(
    response => response
  )
}

// 启用导航
export function nav_active_post(map, option) {
  return post(`${process.env.VUE_APP_NAV}/nav/active`, map, option).then(
    response => response
  )
}

// collection列表
export function nav_col_list_post(map, option) {
  return post(`${process.env.VUE_APP_NAV}/nav/col/list`, map, option).then(
    response => response
  )
}

// 删除导航
export function nav_delete_id_get(map, option) {
  return get(
    `${process.env.VUE_APP_NAV}/nav/delete/${map.id}`,
    map,
    option
  ).then(response => response)
}

// 导航详情
export function nav_detail_id_get(map, option) {
  return get(
    `${process.env.VUE_APP_NAV}/nav/detail/${map.id}`,
    map,
    option
  ).then(response => response)
}

// 查询导航
export function nav_get_post(map, option) {
  return post(`${process.env.VUE_APP_NAV}/nav/get`, map, option).then(
    response => response
  )
}

// 导航列表
export function nav_list_post(map, option) {
  return post(`${process.env.VUE_APP_NAV}/nav/list`, map, option).then(
    response => response
  )
}

// 保存导航
export function nav_save_post(map, option) {
  return post(`${process.env.VUE_APP_NAV}/nav/save`, map, option).then(
    response => response
  )
}
